import React, { useState } from 'react';
import { Modal, Button, Form, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Close from "../../images/close-icon.svg";
import DistanceImage from "../../images/nasionimg.png";

const NasiontoInionModal = ({ showModal, onClose }) => {

  return (
    <Modal
      show={showModal}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      contentClassName="password-modal-content"
      dialogClassName="password-modal-dialog"
    >
      <Link
        variant=""
        onClick={onClose}
        className="modal-close-floating"
        aria-label="Close"
      >
       <Image src={Close} alt=""/>
      </Link>

      <Modal.Body className="password-modal-body p-0">
        <div className="head-bg">
        <h5 className="password-modal-title">Nasion to Inion Distance</h5>
        </div>
        <div className="inner-modal-content inner-radius">

            <Image src={DistanceImage} alt="" className="info-icon"/>
        <p className="password-modal-description mt-4">
          The distance between the  nasion (the indentation between the forehead and nose) and the inion  (the lowest point of the skull on the back of the head) is a crucial  measurement in electroencephalography (EEG) for electrode placement. In adults, this distance typically falls within the range of 32-38 cm.
        </p>

     

        </div>
      
      </Modal.Body>
    </Modal>
  );
};

export default NasiontoInionModal;
